var API={
  // 登录,注册
  login: {
    sign: 'userLogin/login',
    getMenus: 'userLogin/getMenus',
    checkPassword: '/userLogin/isCheckPwdTime',
    updatePassword: '/userLogin/updatePwd',
    firstLoginUpdateUserPassword: '/userLogin/firstLoginUpdateUserPassword',
    signOut: '/userLogin/signOut'
  },
  // 系统管理
  systemanagement: {
    managementList: 'system/list',
    newpreservation: 'system/save',  //新增按钮保存修改按钮保存
    managementview: 'system/get'   //查看按钮
  },
  //用户列表
  userList: {
    PrincipalinterestList: 'user/list',  //用户列表
    modifyaccessInformation: 'user/get',   //修改按钮获取用户信息
    newuserDetails: 'user/saveOrUpdate',   //修改保存，新增按钮保存
    recoveryAuthority: 'user/update',    //恢复按钮
    deletingPermissions: 'user/delete',   //删除按钮
    isUserCheck: 'user/isUserCheck',//校验用户名不能唯一
    managementRole: 'userRole/getUserOfRole',  //管理角色按钮获取角色列表
    addroleList: 'userRole/addRoleList',   //添加按钮获取角色列表
    adduserRoles: 'userRole/save',       //角色列表中添加按钮
    subordinateDepartments: 'department/comdeptinfo',        //所属部门权限管理
    deleteuserRoles: 'userRole/delete',   //删除用户角色
    checkAuthName: 'mockOuterInterface/mockRealNameAuth'  //保存 实名认证校验
  },
  //角色列表
  rolesettingsList: {
    roleacquisitionList: 'role/list',  //角色列表
    roleIncrement: 'role/add',  //角色列表中新增按钮
    priviliegeList: 'role/priviliegeList',  //编辑进入分页角色信息
    editviewAccess: 'role/get',       //编辑查看按钮获取角色信息
    deleteallrolePermissions: 'role/deleteRolePrivilege',     //角色权限删除按钮
    addallroleRights: 'role/save',       //角色新增提交
    rolepermissionPreservation: 'role/saveOrUpdateRolePrivilege',   //角色权限保存按钮
    privilegeManagement: 'role/getAllAuthGroupSys'  //权限管理按钮
  },
  //权限列表
  userrightsList: {
    getpermissionuserList: 'privilege/list',  //权限列表
    permissioneditorViewdetail: 'privilege/get', //编辑查看按钮
    newpermissionDialog: 'privilege/add',   //新增按钮
    permissiontypesystemChange: 'privilege/getPrivilegesBySystem',   //权限类型/所属系统改变的时候
    savebuttoninpermissionAdd: 'privilege/save'     //新增弹窗的保存按钮
  },
  //公司管理
  companymanagement: {
    companyinformationList: 'company/list', //公司列表
    newcompanyInformation: 'company/save',  //新增按钮保存
    newlyacquiredProvinces: 'plug/getCommProvinces',  //新增按钮获取省份
    newacquisitionmarket: 'plug/getCommCity',   //新增按钮获市
    companyModification: 'company/saveOrUpdate',  //修改按钮保存
    companyDeleting: 'company/delete',  //删除按钮
    SinglecompanyRecord: 'company/get'  //修改按钮获取信息
  },
  //部门管理
  managementinDepartment: {
    branchtreediagram: 'department/allDeptList',    //左侧部门树获取
    departmentallist: 'department/list',     //右侧部门列表
    departmentalmodification: 'department/get',  //修改按钮
    modificationdepapreservation: 'department/saveOrUpdate',  //修改部门提交按钮
    departmentaldeletion: 'department/delete',      //删除按钮
    sectorRecovery: 'department/restore',    //恢复按钮
    rolemanagement: 'department/getAllRoleGroupSys',        //角色管理按钮
    rolelistsubmission: 'department/saveOrUpdateDeptRole',     //角色管理提交按钮
    usermanagement: 'department/getAllPersonOfSelect',   //用户管理按钮
    usermanagementsubmission: 'department/saveOrUpdateDeptUser'   //用户管理按钮提交
  },
  //资方材料管理
  materialList: {
    materialList: 'material/list', //资方材料列表
    materialquery: 'material/get', //资方材料修改
    materialSave: 'material/save', //资方材料新增
    materialModify: 'material/update', //资方材料新增
    isMaterialCheck: 'material/isMaterialCheck' //资方影像重复判断
  }


}

export default API



// WEBPACK FOOTER //
// ./src/api/index.js